module.exports = __webpack_public_path__ + "img/terroir-choppy-4.eb34515e.jpg";